<script setup>
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { computed } from 'vue';
import { getInboxIconByType } from 'dashboard/helper/inbox';

const props = defineProps({
  inbox: {
    type: Object,
    default: () => {},
  },
});

const isWhatsAppChannel = computed(() => {
  // Soportar tanto camelCase como snake_case
  const channelType = props.inbox.channelType || props.inbox.channel_type;
  const inboxIdentifier =
    props.inbox.inboxIdentifier || props.inbox.inbox_identifier;
  const identifier = props.inbox.identifier;
  const name = props.inbox.name;
  const medium = props.inbox.medium;

  return (
    // WhatsApp API estándar (Channel::Whatsapp)
    channelType === 'Channel::Whatsapp' ||
    // WAHA API (Channel::Api con identificador waha_)
    (channelType === 'Channel::Api' &&
      ((inboxIdentifier || identifier)?.startsWith('waha_') ||
        name?.toLowerCase().includes('whatsapp'))) ||
    // Twilio WhatsApp (Channel::TwilioSms con medium whatsapp)
    (channelType === 'Channel::TwilioSms' && medium === 'whatsapp')
  );
});

const isOfficialWhatsAppAPI = computed(() => {
  const channelType = props.inbox.channelType || props.inbox.channel_type;
  return channelType === 'Channel::Whatsapp';
});

const inboxIcon = computed(() => {
  const channelType = props.inbox.channelType || props.inbox.channel_type;
  const medium = props.inbox.medium;
  return getInboxIconByType(channelType, medium);
});
</script>

<template>
  <div :title="inbox.name" class="flex items-center gap-1 min-w-0">
    <!-- Icono con color gris para todos los canales -->
    <Icon
      v-if="isWhatsAppChannel"
      icon="i-ri-whatsapp-fill"
      class="size-3 flex-shrink-0 text-n-slate-11"
    />
    <!-- Icono normal para otros canales con color gris -->
    <Icon
      v-else
      :icon="inboxIcon"
      class="size-3 flex-shrink-0 text-n-slate-11"
    />
    <span class="truncate text-label-small text-n-slate-11">
      {{ inbox.name }}
    </span>
    <!-- Badge API para WhatsApp API oficial -->
    <span
      v-if="isOfficialWhatsAppAPI"
      class="px-1 py-0.5 text-xxs font-semibold rounded bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 flex-shrink-0"
    >
      {{ $t('INBOX.API_BADGE') }}
    </span>
  </div>
</template>
